import axios from 'axios';
import store from '../store';
import { clearUser, clearOrganisation } from '../utils/authentication';
import router from '../router';

export const linklistApi = axios.create();

if (window.location.host.indexOf('localhost') >= 0) {
    linklistApi.defaults.baseURL = process.env.VUE_APP_APIBASE;
} else {
    linklistApi.defaults.baseURL =
        window.location.protocol + '//' + window.location.host + '/api/v1/';
}

linklistApi.defaults.headers.common['Accept'] =
    'application/json, text/plain, */*';

// add auth token to request headers
linklistApi.interceptors.request.use(function(config) {
    let authToken =
        store.state.user !== null && store.state.user.token !== undefined
            ? store.state.user.token
            : null;

    if (
        authToken &&
        config.baseURL.indexOf(linklistApi.defaults.baseURL) === 0
    ) {
        config.headers['Authorization'] = `Bearer ${authToken}`;
    }

    return config;
});

linklistApi.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response;
    },
    function(error) {
        if (error.response.status === 400) {
            return error;
        } else if (error.response.status === 422) {
            return error;
        } else if (error.response.status === 403) {
            clearUser();
            clearOrganisation();
            router.push({ path: '/admin/login?logout' });

            return error;
        }
    },
);
